  // eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { ButtonTertiary } from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
// eslint-disable-next-line no-unused-vars
import { FxConfirmationPopUp } from 'axp-fx-common';
// eslint-disable-next-line no-unused-vars
import NavigationHeader from './NavigationHeader';
import labels from '../../constants/labels';
import { notificationData } from './mockData';
// eslint-disable-next-line no-unused-vars
import MenuButton from './MenuButton';
// eslint-disable-next-line no-unused-vars
import HelpMenu from './HelpMenu';

const Header = ({ isAuthenticated, isUnprotected }) => {
  const internetIdentityBaseUrls = useSelector((state) => state.getIn(['config', 'intranetIdentityBaseUrl']));
  const appBaseUrls = useSelector((state) => state.getIn(['config', 'appBaseUrl']));
  const [showLogOutConfirmation, setLogOutConfirmation] = useState(false);

  const onLogOutClick = () => {
    setLogOutConfirmation(true);
  };

  const onLogOutConfirmation = () => {
    const redirectUrl = `${internetIdentityBaseUrls}/en-US/account/logout?DestPage=${appBaseUrls}`;
    window.location.assign(redirectUrl);
    setLogOutConfirmation(false);
  };

  return (
    <>
      {!isUnprotected && (
        <header id="dls-nav" role="banner">
          <div
            style={{
              maxWidth: '1440px',
              margin: 'auto',
            }}
          >
            <nav className="dls-white-bg">
              <div
                className={`container flex flex-align-items-center ${
                  isAuthenticated ? 'flex-justify-between' : 'flex-justify-center'
                }   width-full
              dls-white-bg`}
                style={{ height: '60px' }}
              >
                {isAuthenticated && <MenuButton />}

                <span className="dls-logo-line-md">
                  <img
                    src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/logos/dls-logo-line.svg"
                    alt="American Express"
                  />
                </span>
                {isAuthenticated && (
                  <div className="flex">
                    <HelpMenu />
                    <ButtonTertiary size="sm" onClick={onLogOutClick}>
                      {labels.LOG_OUT}
                    </ButtonTertiary>
                  </div>
                )}
              </div>

              {isAuthenticated && <NavigationHeader notificationData={notificationData} />}
            </nav>
          </div>
        </header>
      )}
      {showLogOutConfirmation && (
        <FxConfirmationPopUp
          heading="Confirm Log Out"
          body="Are you sure you want to log out?"
          primaryButtonLabel={labels.LOG_OUT}
          onPrimaryButtonClick={onLogOutConfirmation}
          tertiaryButtonLabel={labels.CANCEL}
          onTertiaryButtonClick={() => setLogOutConfirmation(false)}
        />
      )}
    </>
  );
};

Header.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isUnprotected: PropTypes.bool.isRequired,
};
export default Header;
